"use client";
import React from "react";
import "./Pets.css";
import AppLayout from "../navigation/Layout/Layout";
import { useTranslation } from "react-i18next";

// ✅ Assets principaux
import petsIllustration from "../assets/svg/pets-illustration.svg";
import petsBlob from "../assets/svg/pets.svg";
import petsSticker from "../assets/svg/pets-bg.svg";

// ✅ Nouveaux éléments décoratifs
import decorLines from "../assets/svg/illustration.svg";

export default function Pets() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <div className="pets-page">
        <div className="pets-hero">
          {/* === décor de fond === */}
          <img src={petsBlob} alt="" className="pets-blob" aria-hidden />
          <img src={petsSticker} alt="" className="pets-sticker" aria-hidden />

          {/* === contenu texte === */}
          <div className="pets-hero__text">
            <h1 className="pets-title">{t("pets.title")}</h1>
            <span className="pets-chip">{t("pets.badgeComingSoon")}</span>

            <div className="pets-subtitle-wrapper">
              <h2 className="pets-subtitle">{t("pets.subtitle")}</h2>
              <img src={decorLines} alt="" className="pets-lines" aria-hidden />
            </div>

            <p className="pets-paragraph">
              {t("pets.paragraph1")}
              <br />
              <br />
              {t("pets.paragraph2")}
            </p>

            <button className="pets-cta" type="button">
              <span className="icon-email" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M22 7L13.009 12.727C12.7039 12.9042 12.3573 12.9976 12.0045 12.9976C11.6517 12.9976 11.3051 12.9042 11 12.727L2 7"
                    stroke="#1e1e1e"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
                    stroke="#1e1e1e"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {t("pets.ctaEmail")}
            </button>
          </div>

          {/* === illustration à droite === */}
          <div className="pets-hero__art" aria-hidden>
            <img
              src={petsIllustration}
              alt={t("pets.illustrationAlt")}
              className="pets-illustration"
              loading="lazy"
            />

       
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
